module.exports = __webpack_public_path__ + "img/siplec-logo.d88ec006.png";